import Image from 'next/image';

import { CardMobile } from '@/components/atomic/atoms';
import { Text } from '@/components/atomic/nuclei';
import { staticMediaStoreBaseURL } from '@/config/common';
import {
  captureGTMEventCTAClick,
  GTM_EVENTS_CTA_NAME,
  PAGE_NAME
} from '@/lib/gtm';

const RoundButtonWithText = ({ link, imageSrc, bottomText }) => (
  <div className='ps-4 pe-12 block'>
    <a
      href={link}
      onClick={() => {
        captureGTMEventCTAClick({
          ctaName: GTM_EVENTS_CTA_NAME.BLOG_VIEW_ALL,
          pageName: PAGE_NAME.HOME_PAGE.label
        });
      }}
    >
      <div className='text-center max-w-18 mx-auto'>
        <div className='bg-more-blog h-17 w-17 rounded-full flex justify-center items-center cursor-pointer shadow-search'>
          <div className='relative h-4'>
            <Image
              alt={bottomText}
              height={15}
              width={21}
              src={imageSrc}
              style={{
                width: '21px',
                height: '15px',
                objectFit: 'contain'
              }}
            />
          </div>
        </div>
        <Text
          {...{
            className:
              'text-nero font-medium font-Inter text-xs leading-4 mt-3',
            content: bottomText
          }}
        />
      </div>
    </a>
  </div>
);

const CardListMobile = ({
  cardList = [],
  imageBasePath,
  imageSlugPrefix,
  isViewButtonVisible,
  viewButtonLink
}) => (
  <div className='ps-2.5 xxxs:ps-5 mt-6'>
    <div className='flex space-x-4 flex-nowrap no-scrollbar items-center card-scroll'>
      {cardList.map(
        ({
          bannerImageUrl,
          id,
          link,
          name,
          slug,
          title,
          yoast_head_json: yoastHeadJson
        }) => {
          let slugParsed = '';
          if (link) {
            slugParsed = link;
          } else if (slug) {
            slugParsed = `${imageSlugPrefix}${slug}`;
          }
          return (
            <CardMobile
              key={id}
              {...{
                bannerImageUrl:
                  yoastHeadJson?.og_image[0]?.url || bannerImageUrl,
                id,
                imageBasePath,
                slug: slugParsed,
                title: title?.rendered || name,
                type: 'blog'
              }}
            />
          );
        }
      )}

      {isViewButtonVisible && (
        <RoundButtonWithText
          {...{
            bottomText: 'View All',
            imageSrc: `${staticMediaStoreBaseURL}/icons/right-white.svg`,
            link: viewButtonLink
          }}
        />
      )}
    </div>
  </div>
);

export default CardListMobile;
